<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'链群人员'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="链群">
							    <el-select v-model="q.jobGroup" :v="q.jobGroup"
							               placeholder="请选择" :clearable="true"
							               @change="okJobPoint">
							        <el-option v-for="(item) in JobGroup"
							                   :key="item.id"
							                   :label="item.jobGroup"
							                   :value="item.jobGroup"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="节点">
							    <el-select v-model="q.jobPoint" :v="q.jobPoint"
							               placeholder="请选择" :clearable="true" :disabled="canjobpoint">
							        <el-option v-for="(item,index) in JobPoint"
							                   :key="index"
							                   :label="item"
							                   :value="item"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="人员">
							    <el-input v-model="q.jobUsernameLike"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
								</el-button>
								<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
								           @click="adduser">新增人员	
								</el-button>
							</el-form-item>
						</div>	
                   
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
							  max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="jobGroup"
                                label="链群"
                                :show-overflow-tooltip="true"
                                min-width="180">
                        </el-table-column>
                        <el-table-column
                                prop="jobGroupPoint"
                                :show-overflow-tooltip="true"
                                label="链群节点"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="jobPoint"
                                :show-overflow-tooltip="true"
                                label="节点"
                                min-width="180">
                        </el-table-column>
                        <el-table-column
                                prop="jobUsername"
                                :show-overflow-tooltip="true"
                                label="人员名称"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="jobUsercode"
                                :show-overflow-tooltip="true"
								width="100"
                                label="人员工号">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="120">
                            <template slot-scope="scope">
								<div class="w-caozuo" style="text-align: left;">
									<el-button
									         type="text"
									         size="small"
									         class="h-tableLink h-btn" @click="handleEdit(scope.row)">
									     修改
									 </el-button>
									 <el-button
									         type="text"
									         size="small"
									         class="h-tableLink h-btn" @click="handleDelete(scope.row)">
									     删除
									 </el-button>
								</div>
                               
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-xg" title="修改" @click="handleEdit(scope.row)"></span>
									<span class="l-operationlist br-operation-delete" title="删除" @click="handleDelete(scope.row)"></span>
								</div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="jobImportExcel"
                                    :startrow="3" @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增人员链群关系</h1>
                            <p>New</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改人员链群关系</h1>
                            <p>Update</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                        <el-form-item label="链群" class="h-elformWrap-2" prop="jobGroup">
                            <el-input v-model.trim="f.jobGroup" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="链群节点" class="h-elformWrap-2" prop="jobGroupPoint">
                            <el-input v-model.trim="f.jobGroupPoint" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="节点" class="h-elformWrap-2" prop="jobPoint">
                            <el-input v-model.trim="f.jobPoint" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="人员名称" class="h-elformWrap-2" prop="jobUsername">
                            <el-input v-model.trim="f.jobUsername" placeholder="请输入"/>
                        </el-form-item>
                        <el-form-item label="人员工号" class="h-elformWrap-2" prop="jobUsercode">
                            <el-input v-model.trim="f.jobUsercode" placeholder="请输入"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                //分页/检索
                q: {
                    jobGroup:null,
                    jobPoint:null,
                    jobUsernameLike:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                    jobGroup:null,
                    jobGroupPoint:null,
                    jobPoint:null,
                    jobUsername: null,
                    jobUsercode:null
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                //弹窗
                dialogFormVisible: false,
                rules:
                    {
                        jobGroup: [{required: true, message: '请输入链群', trigger: 'blur'}],
                        jobGroupPoint: [{required: true, message: '请输入链群节点', trigger: 'blur'}],
                        jobPoint: [{required: true, message: '请选择节点', trigger: 'blur'}],
                        jobUsername: [{required: true, message: '请选择人员名称', trigger: 'blur'}],
                        jobUsercode: [{required: true, message: '请输入人员工号', trigger: 'blur'}],
                    }
            }
        },
        created() {
            this.query();
            this.selectJobGroup();
        },
        methods: {
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    this.canjobpoint = false;
                    ss.UserDemand.selectJobPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.canjobpoint = true;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.UserDemand.selectJobGroup().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.jobGroup = null;
                this.q.jobPoint = null;
                this.q.jobUsernameLike = null;
            },
            query() {
                ss.UserDemand.jobUserPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.saveorupdate = 1
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobGroupPoint = null;
                this.f.jobPoint = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobGroupPoint = null;
                this.f.jobPoint = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                var subflag = false;
                    this.$refs['f'].validate((valid) => {
                        if (valid) {
                            subflag = true;
                        } else {
                            this.$msg.msge("请完善信息后再提交！");
                            return false;
                        }
                    });
                if (subflag == true) {
                    ss.UserDemand.insertJob(this.f).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                        this.dialogFormVisible = false;
                    })
                }
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.UserDemand.deleteJob(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //编辑
            handleEdit(value) {
                this.saveorupdate = 2;
                ss.UserDemand.selectJob(value.id).then(rd => {
                    this.dialogFormVisible = true;
                    this.f = rd;
                })
            },
            //批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/xuqiu/userResDemandJob/downloadExcel", idlist, "post", 'data');
            }
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
</style>
